import style from '../../../styles/Weather/weather_weekly_conditions'

import moment from 'moment'

const utcToLocalTime = utcTime => moment.utc(utcTime).local().format('hh:mm a')

const DayDetails = ({ day }) => {
  const { sunriseTimeUtc = '', sunsetTimeUtc = '', daypart = [] } = day || {}
  const { narrative = '', relativeHumidity = '', uvIndex = '' } = daypart[0] || {}

  return (
    <div className='details-day'>
      {narrative && <p className='description'>{narrative}</p>}
      <div className='row'>
        <span className='heading primary'>Sunrise</span>
        <span className='heading primary'>Sunset</span>
      </div>
      <div className='row'>
        {sunriseTimeUtc && <span className='data secondary'>{utcToLocalTime(sunriseTimeUtc)}</span>}
        {sunsetTimeUtc && <span className='data secondary'>{utcToLocalTime(sunsetTimeUtc)}</span>}
      </div>
      <div className='row'>
        <span className='heading secondary'>Humidity</span>
        {relativeHumidity && <span className='data primary'>{relativeHumidity}</span>}
      </div>
      <div className='row'>
        <span className='heading secondary'>UV Index</span>
        {uvIndex && <span className='data primary'>{uvIndex}</span>}
      </div>
      <style jsx>{style}</style>
    </div>
  )
}

const NightDetails = ({ day }) => {
  const { dayOfWeek = '', moonriseTimeUtc = '', moonsetTimeUtc = '', daypart = [] } = day || {}
  const { narrative = '', windDirectionCardinal = '', windSpeed = '', relativeHumidity = '' } = daypart[1] || {}

  return (
    <div className='details-night'>
      {dayOfWeek && <span className='details-night-heading'>{dayOfWeek} night</span>}
      {narrative && <p className='description'>{narrative}</p>}
      <div className='row'>
        <span className='heading primary'>Moonrise</span>
        <span className='heading primary'>Moonset</span>
      </div>
      <div className='row'>
        {moonriseTimeUtc && <span className='data secondary'>{utcToLocalTime(moonriseTimeUtc)}</span>}
        {moonsetTimeUtc && <span className='data secondary'>{utcToLocalTime(moonsetTimeUtc)}</span>}
      </div>
      <div className='row'>
        <span className='heading secondary'>Wind</span>
        {windDirectionCardinal && windSpeed && (
          <span className='data primary'>{`${windDirectionCardinal} ${windSpeed} mph`}</span>
        )}
      </div>
      <div className='row'>
        <span className='heading secondary'>Humidity</span>
        {relativeHumidity && <span className='data primary'>{relativeHumidity}</span>}
      </div>
      <style jsx>{style}</style>
    </div>
  )
}

const Bottom = ({ day, isCollapsed }) => (
  <div className={`bottom ${isCollapsed ? 'open' : ''}`}>
    <div className='bottom-padding'>
      <DayDetails day={day} />
      <NightDetails day={day} />
    </div>
    <style jsx>{style}</style>
  </div>
)

export default Bottom
